"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableBody = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledTableBody = /*#__PURE__*/_styledComponents.default.tbody.withConfig({
  displayName: "StyledTableBody",
  componentId: "c11n-8-107-0__sc-f04mzl-0"
})([""]);
exports.StyledTableBody = StyledTableBody;